import { connect } from 'react-redux';
import { joinGame,gameStatus,updateParticipation,forceJoinGame } from '../services/request.service';
import { useEffect, useRef, useState } from 'react';
import LoadingPage from '../screens/LoadingPage'
import { useNavigate, useParams } from 'react-router-dom';
import MenuBar from '../svgs/TopbarSvg';
import FootBar from '../svgs/FootbarSvg'
import YearInfo from '../svgs/YearInfoSvg'
import PlayerBackgoundSvg from '../svgs/PlayerBackgoundSvg'
import CardBgSvg from '../svgs/CardBgSvg';
import MenuBtnSvg from '../svgs/MenuBtnSvg';
import MenuBgSvg2 from '../svgs/MenuBtnBgSvg2';
import CrossSvg from '../svgs/CrossSvg';
import AssetIconSvg from '../svgs/AssetIconSvg';
import HexagonSvg from '../svgs/HexagonSvg'
import MenuBtn1 from '../svgs/MenuBtn1';
import MenuBtn2 from '../svgs/MenuBtn2';
import MenuBtn3 from '../svgs/MenuBtn3';
import MenuBtn4 from '../svgs/MenuBtn4';
import TacticResultSvg from '../svgs/TacticResultSvg'
import DownTriangle from '../svgs/DownTriangleSvg';
import LoginPageBgSvg from '../svgs/LoginPageBgSvg';
import StartBtnSvg from '../svgs/StartBtnSvg';
import UserInfoSvg from '../svgs/UserInfoSvg'
import InfoSvg from '../svgs/InfoSvg';
import LeaderBoardPopup from '../components/LeaderBoardPopup';
import InvestmentDetailsPopup from '../components/InvestmentDetailsPopup';
import LeaderBoardBtnSvg from '../svgs/LeaderBoardBtnSvg';
import AssetAllocationPopup from '../components/AssetAllocationPopup'
import CardList from '../components/CardList'
import ScorePopup from '../components/ScorePopup'
import KeyFinancialsDashboard from '../components/KeyFinancialsDashboard';
import MarketRiskCapitalDashboard from '../components/MarketRiskCapitalDashboard'
import TotalPCRDashboard from '../components/TotalPCRDashboard';
import AssetAllocationDashboard from '../components/AssetAllocationDashboard';

import Lottie from 'react-lottie'
import { getCompanyValue, getMarketability, getProfitability, getTVOG, getValueCreationInTheYear, numberWithCommas } from '../gameUtil';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../lottie/ingame.json'),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: require('../lottie/count.json'),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

const maxCardAllocation = 2


function Component(props){
    const navigate = useNavigate();
    const [isloading,setisloading]=useState(false);
    const [data,setdata]=useState({})
    const dataRef= useRef(data)
    dataRef.current=data
    const [showEnvCard,setshowEnvCard]=useState(false);
    let { id } = useParams();


    async function join(){
        if(!id||!props.token?.token||isloading)return
        setisloading(true)
        const result = await joinGame(id,props.token.token);
        fetchGameStatus()
        setisloading(false)
    }

    async function fetchGameStatus(){
        if(!id||isloading)return;
        const result = await gameStatus(id)
        if(result?.errno===0&&result?.result){
            if(!result.result?.game?.[0]?.turns?.[result.result?.game?.[0]?.turn]?.event){
                setshowEnvCard(null)
            }else if( result.result?.game?.[0]?.turns?.[result.result?.game?.[0]?.turn]?.event && 
                (dataRef.current?.game?.[0]?.turns?.[dataRef.current?.game?.[0]?.turn].event?.id) !== (result.result?.game?.[0]?.turns?.[result.result?.game?.[0]?.turn]?.event?.id)
            )
                setshowEnvCard(result.result?.game?.[0]?.turns?.[result.result?.game?.[0]?.turn].event)
            setdata(result.result)
            dataRef.current=result.result
        }else{
            console.log('Fetch data error')
        }
    }

    const [userAction,setuserAction]=useState({})
    const handleAllocateCard=(type,num)=>()=>{
        let d={allocation:{},...userAction}
        const currentNoOfCard=(d.allocation.riskManagement||0) + (d.allocation.aggressive||0)
        if((currentNoOfCard+num <0 )|| (currentNoOfCard+num >maxCardAllocation ))return
        d.allocation[type]=  ((d.allocation[type]||0) + num)<0 ? 0 : (d.allocation[type]||0) + num
        setuserAction(d)
    }

    useEffect(()=>{
        fetchGameStatus()
        const updateInterval= setInterval(()=>{fetchGameStatus()},4000);
        return(() => {clearInterval(updateInterval)})
    },[])
    
    const player=  data?.participations?.find(d=>d?.participantId===props.token?.token);
    const turn = data?.game?.[0]?.turn;
    const event = data?.game?.[0]?.turns?.[turn]?.event
    function isNext(){ 
        return data?.game?.[0]?.status==='player-allocate' && !player?.turns?.[turn].hasSelected
            ? true
            : false
    }

    const next=async ()=>{
        if(isloading)return
        if(!isNext())return;
        if(showEnvCard){
            setshowEnvCard(false)
            return
        }else if(data?.game?.[0]?.status==='player-allocate' && !player?.turns?.[turn].hasSelected){
            const d={
                policyTerm: userAction.policyTerm ?  (parseInt(userAction.policyTerm) ||0) : player?.turns?.[turn].policyTerm,
                guaranteeLevel: userAction.guaranteeLevel ?  (parseInt(userAction.guaranteeLevel) ||0)/100 : player?.turns?.[turn].guaranteeLevel,
                equityAssetAllocation: userAction.equityAssetAllocation ?  (parseInt(userAction.equityAssetAllocation) ||0)/100 : player?.turns?.[turn].equityAssetAllocation,
                participationRate: userAction.participationRate ?  (parseInt(userAction.participationRate) ||0)/100 : player?.turns?.[turn].participationRate,
            }
            setisloading(true)
            const result = await updateParticipation(data?.game?.[0]._id,props.token?.token,player?._id,turn,d)
            if(result?.errno===0){
                fetchGameStatus()
                setuserAction({})
            }
            setisloading(false)
        }
    }

    const updateUserAction=(field)=>(e)=>{
        let d = {...userAction}
        d[field]=e.target.value
        setuserAction(d)
    }

    const handleChooseCard=(item,index)=>()=>{
        let d = {...userAction}
        if((d.selectedCards||[])?.some(c=>c.name===item.name)){
            d.selectedCards=d.selectedCards.filter(c=>c.name!==item.name)
        }else{
            if(d.selectedCards?.length===maxCardAllocation)return
            d.selectedCards=[...(d.selectedCards||[]),item]
        }
        setuserAction(d)
    }
    const handleChooseDD=(item,index)=>()=>{
        let d = {...userAction}
        if((d.selectedDD||[])?.some(c=>c===item)){
            d.selectedDD=d.selectedDD.filter(c=>c!==item)
        }else{
            if(d.selectedDD?.length===maxCardAllocation)return
            d.selectedDD=[...(d.selectedDD||[]),item]
        }
        setuserAction(d)
    }
    const handleInvestments=(item,index)=>(e)=>{
        let d = {...userAction,investments:(userAction.investments||player?.turns?.[turn]?.investments)}
        for(let i of d.investments){
            if(i.name===item){
                i.value=Number(e.target.value)
                setuserAction(d)
                return
            }
        }
        d.investments.push({name:item,value:Number(e.target.value)})
        setuserAction(d)
    }
    const getAvailableCash=()=>{
        let companyList=[]
        for(let company of userAction.investments||[]){
            companyList.push(company.name)
        }
        let thisTurn = player?.turns?.[turn]
        return thisTurn?.cash - (userAction.investments?.reduce((acc,item)=>acc+item?.value,0)||0) - thisTurn?.investments?.filter(c=>!companyList.includes(c.name)).reduce((acc,item)=>acc+item?.value,0) + thisTurn?.investments.reduce((acc,item)=>acc+item?.value,0) 
    }


    const [showMenu,setShowMenu]=useState(null)
    const [isMenu,setisMenu]=useState(null)

    const getPlayerInfo=(index)=>{
        const i = index%data?.participations.length
        if(i===NaN)return {}
        return data?.participations[i]
    }



    const [showLeaderBoard,setshowLeaderBoard]=useState(null)
    const [isLeaderBoard,setisLeaderBoard]=useState(null)
    const handleshowLeaderBoard=()=>{
        if(data?.game?.[0]?.status==='pending')return
        setshowLeaderBoard(true)
        setTimeout(()=>{setisLeaderBoard(true)},500)
    }

    const [showInvestmentDetails,setshowInvestmentDetails]=useState(null)
    const [isInvestmentDetails,setisInvestmentDetails]=useState(null)
    const handleshowInvestmentDetails=()=>{
        if(data?.game?.[0]?.status==='pending')return
        setshowInvestmentDetails(true)
        setTimeout(()=>{setisInvestmentDetails(true)},500)
    }



    const getplayerRank=()=>{
        let d= sortData(data,turn)
        for(let i in d){
            if(d[i]?.participant?.username=== player?.participant?.username)return `${Number(i)+1}/${d.length}`
        }
        return `0/${d.lebgth}`
    }

    function sortData(data,t){
        let turn = t%2===1?t:t-1
        let array = data?.participations?.sort((a,b)=>{
            return   (getCompanyValue(b,turn)||0) - (getCompanyValue(a,turn)||0)
        })
        return array
}

    //Room is waiting for players to join
    if(
        data?.game?.[0]?.status==='pending'
        &&!data?.participations?.some((d)=>d.participantId===props.token?.token)
    )
        return (
            <div className='noselect' style={{width:"100svw",height:'100svh',boxSizing:'border-box',backgroundColor:'black',display:'flex',justifyContent:"center",alignItems:'center',overflow:'hidden'}}>
                <div style={{position:'absolute',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,overflow:'hidden',display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <img src='/countdown.png' style={{width:'100%',objectFit:'cover',position:'absolute',top:0,right:0}} alt='bg'/>
                </div>
                <div style={{position:'absolute',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,overflow:'hidden'}}>
                    <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,zIndex:0}}>
                        <Lottie options={defaultOptions2} loop={true} autoplay={true} style={{width:'100%',height:'100%'}} />
                    </div>
                </div>
                {/* <div style={{position:'absolute',left:'16%',top:'30%'}}>
                    <img src='/bg.png' style={{width:' min( 64svh / 1080 * 1920, 64svw)'}}/>
                </div> */}
                <div style={{position:'absolute',right:'19%',bottom:'52%',fontSize:'min( 3svh / 1080 * 1920, 3svw)',fontWeight:900,color:"white"}}>
                    PART 2
                </div>
                <div style={{position:'relative',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',boxSizing:'border-box'}}>
                    

                    {/* <div style={{position:'absolute',zIndex:0}}>
                        <LoginPageBgSvg width={`min(100vw, ${100/1080*1920}vh )`}/>
                    </div> */}
                    <div className='mousehover' onClick={join}  style={{zIndex:1,marginTop:'10%'}}>
                        <StartBtnSvg/>
                    </div>
                </div>
            </div>
        )


    //Player joined
    if(data?.participations?.some((d)=>d?.participantId===props.token?.token))
      return(
        <div className='noselect' style={{width:"100svw",height:'100svh',boxSizing:'border-box',backgroundColor:'black',display:'flex',justifyContent:"center",alignItems:'center',overflow:'hidden'}}>
            <div style={{position:'absolute',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,overflow:'hidden'}}>
                <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,zIndex:0}}>
                    <Lottie options={defaultOptions} loop={true} autoplay={true} style={{width:'100%',height:'100%'}} />
                </div>
            </div>
            <div style={{position:'relative',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',boxSizing:'border-box',overflow:'hidden'}}>
                
               <PlayerBackgoundSvg width={"min( 20svw, 20svh/1080*1920)"} style={{position:'absolute',bottom:'12%',right:'0%'}}/>
                
                <div style={{position:'absolute',right:'-18%',top:'24%'}}>
                    <div id="rotator">
                        {[1,3,7,5,2,4,8,6].map((item,index)=>
                            <div key={item} className={`userInfo userInfo${Number(index)+1}`}>
                                <UserInfoSvg 
                                    name={getPlayerInfo(item)?.participant?.username||'-'}
                                    solvencyRatio={  numberWithCommas( Math.round(getCompanyValue(getPlayerInfo(item),turn%2===1?turn:turn-1)*100)/100 ) }
                                    style={{position:'absolute',left:"min( -2svw, -2svh/1080*1920)"}}
                                    width={"min( 20svw, 20svh/1080*1920)"
                                }/>
                            </div>
                        )}                   
                    </div>
                </div>

                
                <LeaderBoardBtnSvg onClick={handleshowLeaderBoard} width="min( 5svw, 5svh/1080*1920)" style={{cursor:'pointer',position:'absolute',right:0,top:'38%'}}/>
                <LeaderBoardBtnSvg onClick={handleshowInvestmentDetails} width="min( 3svw, 3svh/1080*1920)" style={{cursor:'pointer',position:'absolute',left:0,bottom:'12%',transform:'rotateY(-180deg)'}}/>


                <MenuBar width={"min( 100svh/ 1080 * 1920, 100svw)"}/>
                <YearInfo width={"min( 43svh/ 1080 * 1920, 43svw)"} style={{position:'absolute',bottom:'29%',right:'19.9%'}}/>
                <HexagonSvg width={`min(18vw, ${18/1080*1920}vh)`} style={{position:'absolute',bottom:'18%',left:'23%'}}/>
                
                
                {/*Name Tag*/}
                <div style={{position:'absolute',top:'2%',left:'2%',fontSize:`min(1.6vw, ${1.6/1080*1920}vh )`,fontWeight:900,color:'black'}}>
                    {player?.participant?.username} Co.
                </div>
                <div style={{position:'absolute',top:'4%',left:'19.5%',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:800,color:'rgb(24,191,205)',textAlign:'left'}}>
                   Comp. Val:&nbsp;${numberWithCommas(  Math.round(  getCompanyValue(player,turn%2===1?turn:turn-1)*100  )/100)}(mil)
                </div>
                <div style={{position:'absolute',top:'4%',left:'37.2%',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:800,color:'rgb(24,191,205)',textAlign:'left',display:'flex',flexDirection:'column'}}>
                    <div style={{display:"flex",flexDirection:'row'}}>
                        Value Creation:
                        &nbsp;{numberWithCommas( Math.round(  getValueCreationInTheYear(player,turn%2===1?turn:turn-1)*100  )/100)}(mil)
                    </div>
                </div>
                {/* <div style={{position:'absolute',top:'2%',left:'51%',height:'8%',width:2,backgroundColor:'rgb(24,191,205)'}}/> */}
                <div style={{position:'absolute',top:'4%',left:'56.5%',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:800,color:'rgb(24,191,205)',textAlign:'left'}}>
                    <div style={{display:"flex",flexDirection:'row',alignItems:'center'}}>
                        Marketability factor:
                        &nbsp;{numberWithCommas( Math.round(  getMarketability(player,turn%2===1?turn:turn-1)*100  )/100)}
                    </div>
                </div>
                <div style={{position:'absolute',top:'4%',left:'78.5%',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:800,color:'rgb(24,191,205)',textAlign:'left'}}>
                    <div style={{display:"flex",flexDirection:'row'}}>
                        Profitability:
                        &nbsp;{numberWithCommas( Math.round(  getProfitability(player,turn%2===1?turn:turn-1)*100  )/100)}(mil)
                    </div>
                </div>
                <div style={{position:'absolute',top:'7.6%',left:'4.7%',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:800,color:'rgb(24,191,205)',textAlign:'left',maxWidth:`min(18vw, ${18/1080*1920}vh )`}}>
                    Rank: {getplayerRank()}
                </div>
                {/* {data?.game?.[0]?.status==='pending'||<div style={{position:'absolute',top:'19%',left:'%',width:"28%",backgroundColor:"white",fontSize:`min(1.2vw, ${1.2/1080*1920}vh )`,fontWeight:800,color:'black',padding:`min(.5vw, ${.5/1080*1920}vh )`}}>
                  <div style={{display:'flex',flexDirection:"column",gap:2,padding:'2%'}}>
                        <div style={{marginBottom:4,borderBottom:'1px solid rgb(24,191,205)',paddingBottom:4}}>Investment Valuation (Beginning of year):</div>
                        
                        
                    </div>
                </div>} */}
                {/* <div style={{position:'absolute',top:'11.4%',left:'25%',fontSize:`min(1.8vw, ${1.8/1080*1920}vh )`,fontWeight:900,color:'rgb(24,191,205)',textAlign:'left',
                    color:data?.game?.[0]?.status==='player-allocate'
                        ?'Orange'
                        :data?.game?.[0]?.status==='admin-turn'
                        ?'Red'
                        :'Green'
                }}>
                   {data?.game?.[0]?.status==='player-allocate'
                    ?'Player Turn'
                    :data?.game?.[0]?.status==='admin-turn'
                    ?'Risk Event Turn'
                    :'Pending'
                    }
                </div> */}
            
                
                
                {/*Tactic Result*/}
                {(data?.game?.[0]?.status==='player-allocate'&&( userAction?.selectedCards?.length>0))
                &&<div style={{position:'absolute',top:'0%',right:'0%',fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,fontWeight:700,color:'black',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'space-between',backgroundColor:'transparent'}}>
                    <TacticResultSvg width='min(40vw, 40/1080*1920vh)'/>
                    <div style={{width:'53%',height:'63%',position:'absolute',backgroundColor:'#f7076700',right:'2%',top:'18.5%',overflowY:'auto'}}>
                        <div style={{width:'100%',textAlign:'left',marginBottom:`min(1.5vw, ${1.5/1080*1920}vh )`}}>Allocation Result</div>
                        {   (userAction?.selectedCards?.some(c=>c.type==='debtRatio') ||  (player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='debtRatio')  )
                            &&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                                <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:400}}>
                                    Debt Ratio
                                </div>
                                <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end"}}>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'#717171'}}>
                                        {Math.round(player?.turns?.[turn]?.debtRatio*100||0)}&nbsp;%
                                    </div>
                                    <div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(This Year)&nbsp;</div>
                                        {   
                                            (()=>{
                                                let a=  Math.round( (player?.turns?.[turn]?.debtRatio + (userAction?.selectedCards?.filter(c=>c.type==='debtRatio')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*100 )
                                                a= a<0?0:a
                                                return a>99?99:a
                                            })()
                                           
                                        }&nbsp;%
                                    </div>
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='debtRatio')&&<div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='debtRatio')&&
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(Progressive Inc./Dec.) &nbsp;</div>
                                        {   
                                            (()=>{
                                                let a=  Math.round( (player?.turns?.[turn]?.debtRatio + (userAction?.selectedCards?.filter(c=>c.type==='debtRatio')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)  + ((player?.turns?.[turn]?.selectedCardsEveryYear||[])?.filter(c=>c.type==='debtRatio')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*100 )
                                                a= a<0?0:a
                                                return a>99?99:a
                                            })()
                                           
                                        }&nbsp;%
                                    </div>}
                                </div>
                            </div>
                        }
                        {   (userAction?.selectedCards?.some(c=>c.type==='profitMargin') ||  (player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='profitMargin')  )
                            &&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                                <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:400}}>
                                    Profit Margin
                                </div>
                                <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end"}}>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'#717171'}}>
                                        {Math.round(player?.turns?.[turn]?.profitMargin*100||0)}&nbsp;%
                                    </div>
                                    <div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(This Year)&nbsp;</div>
                                        {Math.round( (player?.turns?.[turn]?.profitMargin + (userAction?.selectedCards?.filter(c=>c.type==='profitMargin')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*10000 )/100}&nbsp;%
                                    </div>
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='profitMargin')&&<div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='profitMargin')&&
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                    <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(Progressive Inc./Dec.) &nbsp;</div>
                                        {Math.round( (player?.turns?.[turn]?.profitMargin + (userAction?.selectedCards?.filter(c=>c.type==='profitMargin')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)  + ((player?.turns?.[turn]?.selectedCardsEveryYear||[])?.filter(c=>c.type==='profitMargin')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*10000 )/100}&nbsp;%
                                    </div>}
                                </div>

                            </div>
                        }
                        {   (userAction?.selectedCards?.some(c=>c.type==='interestRate') ||  (player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='interestRate')  )
                            &&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                                <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:400}}>
                                    Interest Rate
                                </div>
                                <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end"}}>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'#717171'}}>
                                        {Math.round(player?.turns?.[turn]?.interestRate*100||0)}&nbsp;%
                                    </div>
                                    <div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(This Year)&nbsp;</div>
                                        {   
                                            (()=>{
                                                let a=  Math.round( (player?.turns?.[turn]?.interestRate + (userAction?.selectedCards?.filter(c=>c.type==='interestRate')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*100 )
                                                return a= a<0?0:a
                                            })()
                                           
                                        }&nbsp;%
                                    </div>
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='debtRatio')&&<div><DownTriangle width='min(1vw, 1/1080*1920vh)'/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}
                                    {(player?.turns?.[turn]?.selectedCardsEveryYear||[])?.some(c=>c.type==='debtRatio')&&
                                    <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,color:'black',flexDirection:'row',display:'flex',alignItems:'flex-end'}}>
                                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:300,color:'black'}}>(Progressive Inc./Dec.) &nbsp;</div>
                                        {   
                                            (()=>{
                                                let a=  Math.round( (player?.turns?.[turn]?.interestRate + (userAction?.selectedCards?.filter(c=>c.type==='interestRate')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)  + ((player?.turns?.[turn]?.selectedCardsEveryYear||[])?.filter(c=>c.type==='interestRate')?.reduce((acc,v)=>acc+(v?.value||0),0)||0)   )*100 )
                                                return a= a<0?0:a
                                            })()
                                           
                                        }&nbsp;%
                                    </div>}
                                </div>
                            </div>
                        }
                            
                    </div>
                </div>}



                {/*Event Result*/}
                {/* {(showEnvCard)
                &&<div style={{position:'absolute',top:'0%',right:'0%',fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,fontWeight:700,color:'black',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'space-between',backgroundColor:'transparent'}}>
                    <TacticResultSvg width='min(40vw, 40/1080*1920vh)'/>
                    <div style={{width:'53%',height:'63%',position:'absolute',backgroundColor:'#f7076700',right:'2%',top:'18.5%',overflowY:'auto'}}>
                        <div style={{width:'100%',textAlign:'left',marginBottom:`min(1.5vw, ${1.5/1080*1920}vh )`}}>Event Result</div>
                        {showEnvCard.type==='profitMargin'&&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"#147866"}}>
                                Profit Margin 
                            </div>
                            <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end",fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:400}}>
                               {Math.round(player?.turns?.[turn].profitMargin*100)/1}% {'->'}  {Math.round((player?.turns?.[turn].profitMargin+showEnvCard?.value)*100)/1}%
                            </div>
                        </div>}
                        {showEnvCard.type==='growthRate'&&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"#147866"}}>
                                Growth Rate 
                            </div>
                            <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end",fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:400}}>
                               {Math.round(player?.turns?.[turn].growthRate*100)/1}% {'->'}  {Math.round((player?.turns?.[turn].growthRate+showEnvCard?.value)*100)/1}%
                            </div>
                        </div>}
                        {showEnvCard.type==='interestRate'&&<div style={{width:'100%',borderTop:'1px solid #00C9D6',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"#147866"}}>
                                Interest Rate 
                            </div>
                            <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end",fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:400}}>
                               {Math.round(player?.turns?.[turn].interestRate*100)/1}% {'->'}  {Math.round((player?.turns?.[turn].interestRate+showEnvCard?.value)*100)/1}%
                            </div>
                        </div>}
                        {showEnvCard.id===4&&<div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"#147866"}}>
                                Profit Margin 
                            </div>
                            <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end",fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:400}}>
                               {Math.round(player?.turns?.[turn].profitMargin*100)/1}% {'->'}  {Math.round((player?.turns?.[turn].profitMargin+(player?.turns?.[turn]?.type.includes('Tech')?.2:.06))*100)/1}%
                            </div>
                        </div>}
                        {showEnvCard.id===3&&<div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"#147866"}}>
                                Interest Rate 
                            </div>
                            <div style={{display:'flex',display:'flex',flexDirection:'column',alignItems:"flex-end",fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:400}}>
                               {Math.round(player?.turns?.[turn].profitMargin*100)/1}% {'->'}  {Math.round((player?.turns?.[turn].profitMargin+0.05)*100)/1}%
                            </div>
                        </div>}
                        {showEnvCard.id===5&&<div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',padding:'min(1vw, 1/1080*1920vh) 0px'}}>
                            <div style={{flex:1,display:'flex',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:'900',color:"grey"}}>
                                Nothing Happens
                            </div>
                        </div>}
                      
                    </div>
                </div>} */}
                <FootBar isNext={isNext()} next={next} width={"min(100svh/1080 * 1920, 100svw)"} style={{position:'absolute',bottom:0,right:0}}/>
                {/*back btn*/}
                <div onClick={()=>{navigate('/')}} style={{position:'absolute',bottom:0,left:0,width:'4%',height:'8%',backgroundColor:"transparent",cursor:'pointer'}}>
                </div>



                {/*Chapter Tag*/}
                {data?.game?.[0]?.status!=='pending'&&<div style={{position:'absolute',top:'30.5%',left:'48.1%',fontSize:`min(1.7vw, ${1.7/1080*1920}vh )`,fontWeight:700,color:'white'}}>
                    Year {Math.floor(data?.game?.[0]?.turn/2)+1}
                </div>}
                {/*solvency ratio & ROC*/}
                {data?.game?.[0]?.status==='pending'?
                    <div style={{position:'absolute',top:'34%',left:'46%',width:'9%',height:'29%',color:'black',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <div style={{fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,fontWeight:700}}>Waiting for host to start game... </div>
                    </div>
                    :data?.game?.[0]?.status==='admin-turn'
                    ?<div onClick={()=>{setshowEnvCard(data?.game?.[0]?.turns?.[turn]?.event)}} style={{cursor:'pointer',position:'absolute',top:'34%',left:'46%',width:'9%',height:'29%',color:'black',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700}}>Comp. Val:</div>
                        <div style={{fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,color:'#00C9D6',fontWeight:700}}>{numberWithCommas(  Math.round(  getCompanyValue(player,turn%2===1?turn:turn-1)*100  )/100)}(mil)</div>
                        <div style={{fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,marginTop:'1vw'}}>TVOG:</div>
                        <div style={{fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,color:'#00C9D6',fontWeight:700}}>{numberWithCommas(  Math.round(  getTVOG(player,turn%2===1?turn:turn-1)*100  )/100)}(mil)</div>
                    </div>
                    :data?.game?.[0]?.status==='player-allocate'
                    ?<div onClick={()=>{setshowEnvCard(data?.game?.[0]?.turns?.[turn]?.event)}} style={{cursor:'pointer',position:'absolute',top:'34%',left:'46%',width:'9%',height:'29%',color:'black',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:700}}>
                            {
                                player?.turns?.[turn]?.hasSelected
                                ?'Waiting for other players...'
                                :'Set your policy matrix wisely...'
                            }
                        </div>
                    </div>
                    :<div style={{position:'absolute',top:'34%',left:'46%',width:'9%',height:'29%',color:'black',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:400}}>
                            
                        </div>
                    </div>
                }
 


                {/* choose card type */}
                {(data?.game?.[0]?.status==='player-allocate')
                    ?<div style={{position:'absolute',display:'flex',flexDirection:'row',bottom:0,left:'5.7%',width:'76%',alignItems:'flex-end',justifyContent:'flex-start',paddingBottom:'2%',paddingLeft:'1.5%',fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`,}}>
                        <div style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,fontWeight:700}}>Allocate your tactic pool</div>
                        <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'flex-start',gap:'2%',marginLeft:'8%',marginRight:'10%', backgroundColor:"#00000020",padding:'1% 1%',borderRadius:"8px",gap:'1vw'}}>
                            <div style={{display:"flex",flexDirection:"row",gap:'2%',width:'100%',justifyContent:"space-between"}}>
                                <div style={{flex:1,textAlign:'left'}}>Policy Term:</div>
                                <div style={{fontWeight:"bold"}}>{Math.round(userAction.policyTerm??player.turns?.[turn]?.policyTerm)}</div>
                                <input disabled={player?.turns?.[turn]?.hasSelected} value={userAction.policyTerm??player.turns?.[turn]?.policyTerm} min={1} max={player.turns?.[turn]?.maxPolicyTerm} onChange={updateUserAction('policyTerm')} type='range' style={{borderRadius:4,width:"30%"}}/>
                            </div>
                            <div style={{display:"flex",flexDirection:"row",gap:'2%',width:'100%',justifyContent:"space-between"}}>
                                <div style={{flex:1,textAlign:'left'}}>Guarantee Level: </div>
                                <div style={{fontWeight:"bold"}}>{Math.round(userAction.guaranteeLevel??player.turns?.[turn]?.guaranteeLevel*100)}%</div>
                                <input disabled={player?.turns?.[turn]?.hasSelected} value={(userAction?.guaranteeLevel)??player.turns?.[turn]?.guaranteeLevel*100} min={0} max={6} onChange={updateUserAction('guaranteeLevel')} type='range' style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,borderRadius:4,width:"30%"}}/>
                            </div>
                            <div style={{display:"flex",flexDirection:"row",gap:'2%',width:'100%',justifyContent:"space-between"}}>
                                <div style={{flex:1,textAlign:'left'}}>Equity Asset Allocation: </div>
                                <div style={{fontWeight:"bold"}}>{Math.round(userAction.equityAssetAllocation??player.turns?.[turn]?.equityAssetAllocation*100)}%</div>
                                <input disabled={player?.turns?.[turn]?.hasSelected} value={userAction.equityAssetAllocation??player.turns?.[turn]?.equityAssetAllocation*100} min={0} max={100} onChange={updateUserAction('equityAssetAllocation')} type='range' style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,borderRadius:4,width:"30%"}}/>
                            </div>
                            <div style={{display:"flex",flexDirection:"row",gap:'2%',width:'100%',justifyContent:"space-between"}}>
                                <div style={{flex:1,textAlign:'left'}}>Policyholders' Participation Rate: </div>
                                <div style={{fontWeight:"bold"}}>{Math.round(userAction.participationRate??player.turns?.[turn]?.participationRate*100)}%</div>
                                <input disabled={player?.turns?.[turn]?.hasSelected} value={userAction.participationRate??player.turns?.[turn]?.participationRate*100} min={10} max={90} onChange={updateUserAction('participationRate')} type='range' style={{fontSize:`min(1vw, ${1/1080*1920}vh )`,borderRadius:4,width:"30%"}}/>
                            </div>
                        </div>
             
                    </div>
                    : (data?.game?.[0]?.status === 'admin-turn') 
                    ? <div style={{position:'absolute',display:'flex',flexDirection:'row',bottom:0,left:'10.7%',width:'76%',alignItems:'flex-end',justifyContent:'center',paddingBottom:'2%',paddingLeft:'1.5%'}}>
                        <div style={{fontSize:`min(2vw, ${2/1080*1920}vh )`,fontWeight:700}}>Risk Event Turn</div>
                    </div>
                    :<div/>
                }

                {/* Env Card*/}
                {showEnvCard&&<div style={{position:'absolute',left:'34%',top:'10%'}}>
                    <div style={{height:`min(45vw, ${45/1080*1920}vh)`,boxSizing:"border-box",display:'flex',flexDirection:"column",justifyContent:'center',alignItems:'center'}}>
                        <img
                            alt='env card'
                            src={`/cards/e${showEnvCard?.id}.png`}
                            style={{cursor:'pointer',height:'100%',objectFit:'cover' }}
                        />
                    </div>
                </div>}


                {/*Menu buttons */}
                <div onClick={()=>{setisMenu(1);setTimeout(()=>{setShowMenu(1)},200)}} className='mousehover' style={{position:'absolute',top:'11%',left:'2.2%',width:'14%',height:'11%',backgroundColor:'transparent',fontSize:'min( 1svh/ 1080 * 1920, 1svw)',color:'black',display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'700'}}>
                &nbsp; &nbsp; &nbsp; Key Financials
                </div>
                <div onClick={()=>{setisMenu(2);setTimeout(()=>{setShowMenu(2)},200)}} className='mousehover' style={{position:'absolute',top:'11%',left:'17.5%',width:'8%',height:'14%',backgroundColor:'transparent',fontSize:'min( 1svh/ 1080 * 1920, 1svw)',color:'black',display:'flex',flexDirection:'column',justifyContent:'flex-end',alignItems:'center',fontWeight:'700'}}>
                TVOG
                </div>
                <div onClick={()=>{setisMenu(3);setTimeout(()=>{setShowMenu(3)},200)}} className='mousehover' style={{position:'absolute',top:'11%',left:'26.6%',width:'8%',height:'14%',backgroundColor:'transparent',fontSize:'min( 1svh/ 1080 * 1920, 1svw)',color:'black',display:'flex',flexDirection:'column',justifyContent:'flex-end',alignItems:'center',fontWeight:'700'}}>
                Return
                </div>
                <div onClick={()=>{setisMenu(4);setTimeout(()=>{setShowMenu(4)},200)}} className='mousehover' style={{position:'absolute',top:'11%',left:'35.3%',width:'8%',height:'14%',backgroundColor:'transparent',fontSize:'min( 1svh/ 1080 * 1920, 1svw)',color:'black',display:'flex',flexDirection:'column',justifyContent:'flex-end',alignItems:'center',fontWeight:'700'}}>
                Assumption
                </div>
                <div className='myblur' style={{position:'absolute',top:0,left:isMenu?0:"-200%",width:'100%',height:'100%',backgroundColor: 'rgba(0, 0, 0, 0.20)',backdropFilter:'blur(10px)',transition:'.2s all ease',opacity:showMenu?1:0,overflow:'hidden',zIndex:5}}>
                    <div style={{display:'flex',flexDirection:'row',position:'absolute',left:showMenu?0:'-200%',top:0,width:'100%',height:'100%',transition:'.5s all ease'}}>
                        <div style={{display:'flex',flexDirection:'column',height:'100%',justifyContent:'space-between',boxSizing:'border-box',padding:'4% 3%'}}>
                            <div className='mousehover' onClick={()=>{setisMenu(1);setShowMenu(1)}} style={{position:'relative',display:'flex',flexDirection:'column',color:'white',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,justifyContent:'center',alignItems:'center'}}>
                                <MenuBtnSvg color='#0AC5A3'isSelected={isMenu===1} width={"min( 8svh/ 1080 * 1920, 8svw)"}/>
                                <div style={{position:'absolute',top:'15%'}}><MenuBtn1 width={"min( 5svh/ 1080 * 1920, 5svw)"}/></div>
                                {isMenu===1&&<div style={{position:'absolute',top:'-3.8%'}}><MenuBgSvg2 width={"min( 10svh/ 1080 * 1920, 10svw)"}/></div>}
                                <div style={{marginTop:'min( .5svh/ 1080 * 1920, .5svw)'}}>Key Financials</div>
                            </div>
                            <div className='mousehover' onClick={()=>{setisMenu(2);setShowMenu(2)}} style={{position:'relative',display:'flex',flexDirection:'column',color:'white',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,justifyContent:'center',alignItems:'center'}}>
                                <MenuBtnSvg color='#FF7272' isSelected={isMenu===2} width={"min( 8svh/ 1080 * 1920, 8svw)"}/>
                                <div style={{position:'absolute',top:'12.5%'}}><MenuBtn2 width={"min( 5svh/ 1080 * 1920, 5svw)"}/></div>
                                {isMenu===2&&<div style={{position:'absolute',top:'-2.3%'}}><MenuBgSvg2 width={"min( 10svh/ 1080 * 1920, 10svw)"}/></div>}
                                <div style={{marginTop:'min( .5svh/ 1080 * 1920, .5svw)'}}>TVOG</div>
                            </div>
                            <div className='mousehover' onClick={()=>{setisMenu(3);setShowMenu(3)}} style={{position:'relative',display:'flex',flexDirection:'column',color:'white',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,justifyContent:'center',alignItems:'center'}}>
                                <MenuBtnSvg color='#027E87' isSelected={isMenu===3} width={"min( 8svh/ 1080 * 1920, 8svw)"}/>
                                <div style={{position:'absolute',top:'15%'}}><MenuBtn3 width={"min( 5svh/ 1080 * 1920, 5svw)"}/></div>
                                {isMenu===3&&<div style={{position:'absolute',top:'-3.3%'}}><MenuBgSvg2 width={"min( 10svh/ 1080 * 1920, 10svw)"}/></div>}
                                <div style={{marginTop:'min( .5svh/ 1080 * 1920, .5svw)'}}>Returns</div>
                            </div>
                            <div className='mousehover' onClick={()=>{setisMenu(4);setShowMenu(4)}} style={{position:'relative',display:'flex',flexDirection:'column',color:'white',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:700,justifyContent:'center',alignItems:'center'}}>
                                <MenuBtnSvg color="#FF9900" isSelected={isMenu===4} width={"min( 8svh/ 1080 * 1920, 8svw)"}/>
                                <div style={{position:'absolute',top:'15%'}}><MenuBtn4 width={"min( 5svh/ 1080 * 1920, 5svw)"}/></div>
                                {isMenu===4&&<div style={{position:'absolute',top:'-3.3%'}}><MenuBgSvg2 width={"min( 10svh/ 1080 * 1920, 10svw)"}/></div>}
                                <div style={{marginTop:'min( .5svh/ 1080 * 1920, .5svw)'}}> Assumption</div>
                            </div>
                        </div>

                        {isMenu===1
                            ?<KeyFinancialsDashboard player={player} turn={turn%2==1?turn:turn-1} data={data} event={event}/>
                            :isMenu===2
                            ?<MarketRiskCapitalDashboard  player={player} turn={turn%2==1?turn:turn-1} data={data} event={event}/>
                            :isMenu===3
                            ?<TotalPCRDashboard player={player} turn={turn%2==1?turn:turn-1} data={data} event={event}/>
                            :isMenu===4
                            ?<AssetAllocationDashboard player={player} turn={turn%2==1?turn:turn-1} data={data} event={event} />
                            :<div/>
                        }
                        
                    </div>
                    <div onClick={()=>{setShowMenu(null);setTimeout(()=>{setisMenu(null)},200)}} style={{position:'absolute',right:'2%',top:'2%'}}>
                        <CrossSvg width={`min( 7svh/ 1080 * 1920, 7svw)`}/>
                    </div>
                </div>

                
                {showLeaderBoard&&<LeaderBoardPopup
                    setshowLeaderBoard={setshowLeaderBoard}
                    setisLeaderBoard={setisLeaderBoard}
                    isLeaderBoard={isLeaderBoard}
                    showLeaderBoard={showLeaderBoard}
                    data={data}
                />}
                {showInvestmentDetails&&<InvestmentDetailsPopup
                    setshowLeaderBoard={setshowInvestmentDetails}
                    setisLeaderBoard={setisInvestmentDetails}
                    isLeaderBoard={isInvestmentDetails}
                    showLeaderBoard={showInvestmentDetails}
                    data={data}
                    token={props.token}
                />}

                {isloading&&<LoadingPage/>}
            </div>
        </div>
    )

    //Game started. Player cannot join
    return (
        <div className='noselect' style={{width:"100svw",height:'100svh',boxSizing:'border-box',backgroundColor:'black',display:'flex',justifyContent:"center",alignItems:'center',overflow:'hidden'}}>
            <div style={{position:'relative',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',backgroundColor:'rgb(212,212,212)',boxSizing:'border-box'}}>
                

                {/* <div style={{position:'absolute',zIndex:0}}>
                    <LoginPageBgSvg width={`min(100vw, ${100/1080*1920}vh )`}/>
                </div> */}
                <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,zIndex:0}}>
                    <Lottie options={defaultOptions} loop={true} autoplay={true} style={{width:'100%',height:'100%'}} />
                </div>
                {/* <div className='mousehover' onClick={forceJoin}  style={{zIndex:1}}>
                    <StartBtnSvg/>
                </div> */}
                <div className='mousehover' style={{zIndex:1,color:'black',fontWeight:700,fontSize:36}}>
                    Game Already Started
                </div>
            </div>
        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Component)
  